export default __webpack_public_path__ + "static/media/jen_membership4.117952e6.svg";